import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../shared/toastpayload";

// export interface toastPayload {
//   message: string;
//   title: string;
//   ic: IndividualConfig;
//   type: string;
// }

@Injectable({
  providedIn: 'root'
})

export class ToasterserviceService {

  constructor(private toastr: ToastrService) {

      // Define toastr GlobalConfig
      this.toastr.toastrConfig.enableHtml = true;
   }

  showToast(toast: Toastpayload) {
    
    this.toastr.show(
      toast.message,
      toast.title,
      toast.ic,
      'toast-' + toast.type
    );
  }

}
